(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/payment/payment/assets/context/create-middleware-context-api.js') >= 0) return;  svs.modules.push('/components/payment/payment/assets/context/create-middleware-context-api.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$components$payme = svs.components.payment.payment,
  createPaymentInfo = _svs$components$payme.createPaymentInfo,
  createTasks = _svs$components$payme.createTasks;

const createPayableContextApi = payableItems => {
  const _payableItems = Object.freeze([...payableItems]);
  let paidPayableCount = 0;
  const getTotalPrice = () => _payableItems.reduce((sum, payable) => sum + payable.price, 0);
  const count = () => _payableItems.reduce((sum, payable) => sum + payable.count, 0);
  const getPayableItems = () => _payableItems;
  const getUnpaidCount = () => _payableItems.length - paidPayableCount;
  const getPayableType = () => {
    const type = _payableItems[0].type;
    const isSameType = _payableItems.every(payable => payable.type === type);
    if (!isSameType) {
      throw new Error('All payable items must be of the same type');
    }
    return type;
  };
  const context = Object.freeze({
    getTotalPrice,
    count,
    getPayableItems,
    getPayableType,
    getUnpaidCount,
    tasks: createTasks(),
    paymentResponse: {}
  });
  const setPaidCount = count => {
    paidPayableCount = count;
  };
  const updatePaymentResponse = response => {
    context.paymentResponse.result = response[0];
    if (response[1] && !response[1].handledError) {
      context.paymentResponse.error = response[1];
    }
  };
  const updateContext = Object.freeze({
    setPaidCount,
    updatePaymentResponse
  });
  return [context, updateContext];
};

const createMiddlewareContextApi = function (payableItems, observers) {
  let userContext = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const _createPayableContext = createPayableContextApi(payableItems),
    _createPayableContext2 = _slicedToArray(_createPayableContext, 2),
    payableContextApi = _createPayableContext2[0],
    payableUpdateContextApi = _createPayableContext2[1];
  const context = Object.freeze({
    payment: payableContextApi,
    observers,
    paymentInfo: createPaymentInfo(),
    userContext
  });
  const updateContext = Object.freeze({
    payment: payableUpdateContextApi
  });
  return [context, updateContext];
};
setGlobal('svs.components.payment.payment.context.createMiddlewareContextApi', createMiddlewareContextApi);

 })(window);